module.exports = __webpack_public_path__ + "img/patternmaster.7ad52be8.png";